import styled from 'styled-components';
import { desktop_breakpoint } from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';

export const LandListingItemStyles = styled.div`
  border-bottom: 1px solid ${Colors.primary.black.tint};
  min-height: 160px;
  padding: 25px 0;
  position: relative;

  .constrained-width {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    min-height: 100%;
  }

  .listing-details {
    display: flex;
    flex-direction: column;

    h5,
    h6,
    span {
      line-height: 1.69;
      margin-top: 5px;
    }

    .listing-address {
      line-height: 1.4;
      margin-top: 5px;
    }
  }

  .listing-size {
    margin-top: 5px;
  }

  //navigation map markers
  .map-marker-area {
    display: none;
    margin-top: 12px;
    margin-right: 5px;
  }

  .listing-header {
    display: flex;
    flex-direction: row;

    .listing-broker {
      display: none;
    }

    .listing-broker-mobile {
      display: block;
      font-size: 16px;
    }

    h5 {
      display: block;
    }

    a:link,
    a:visited,
    a:hover,
    a:active {
      text-align: left;
      text-decoration: none;
    }
  }

  .listing-references {
    align-items: flex-end;
    display: flex;
    flex-direction: column;
    min-height: 100%;
    justify-content: space-between;

    .listing-thumbnail {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 90px;
      overflow: hidden;
      padding-left: 8px;
      position: relative;
      width: 141px;
    }

    a.xsmall {
      color: ${Colors.primary.claytonBlue.standard};
      font-weight: 600;
      letter-spacing: 1px;
      text-decoration: none;
      white-space: nowrap;
    }
  }

  img {
    display: none;
  }

  //for desktop only, show the map, and map pins.
  @media screen and (min-width: ${desktop_breakpoint}px) {
    &.selected {
      background-color: ${Colors.accent.veryLightBlue.standard};
    }

    img {
      display: block;
    }

    .map-marker-area {
      display: block;
    }

    .listing-address,
    .listing-size {
      margin-left: 30px;
    }

    .listing-header {
      .listing-broker {
        display: block;
      }
      .listing-broker-mobile {
        display: none;
      }
    }
  }
`;
